import { defineStore } from "pinia";
import { UnitData } from "./app-state";

export const appStore = defineStore('counterStore', {
  state: () => ({
    siteSVG: '',
    floorplanFilter: '',
    statusFilter: '',
    unitsData: [] as UnitData[],
  })
});
